/**
 * Kurum fiş yazıcısı kullanıyor mu (Ayarlar > Yazıcılar, "Fiş yazıcısı
 * kullan"; 28 Eki 2026). Kapalıyken hiçbir yol fiş basmaz: yazdırma işlevi
 * (App.print) en başta buna bakıyor, düğmeler gizlense de gözden kaçan bir
 * yol yazdırma penceresi açmasın.
 *
 * Modül düzeyinde, çünkü App.print AuthProvider'ın dışında tanımlı;
 * AuthProvider kurum ayarı geldikçe burayı güncelliyor.
 */
let enabled = true

export function setPrintingEnabled(on: boolean): void {
  enabled = on
}

export function isPrintingEnabled(): boolean {
  return enabled
}
